import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";


const renderRoutes = (routes: any, outerProps = {}) => {
  return routes ? (
    <Switch>
      {routes
        .filter((route: any) => route.redirect)
        .map((route: any, i: any) => (
          <Redirect
            key={i}
            exact={true}
            from={route.path}
            to={route.redirect}
          />
        ))}
      {routes.map((route: any, i: any) => {
        return route.component ? (
          <Route
            key={i}
            path={route.path}
            exact={route.exact ? true : false}
            render={(props) => (
              <route.component
                {...props}
                {...outerProps}
                routes={route.routes}
                currentMenuItem={route}
              />
            )}
          />
        ) : (
          <Redirect key={100000} exact={true} to={"/landing"} />
        );
      })}
    </Switch>
  ) : null;
};

export { renderRoutes };
